import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import type { GetBanksRequest, GetBanksResponse } from "./types";
import { baseQueryCreator } from "redux/baseQuery";
import env from "env";

const { bankService } = env.api.baseUrl;

const baseQuery = fetchBaseQuery({
  baseUrl: bankService,
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as any).auth.accessToken;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

export const bankApi = createApi({
  reducerPath: "bankApi",
  baseQuery: baseQueryCreator(baseQuery),
  refetchOnMountOrArgChange: true,
  tagTypes: ["Bank"],
  endpoints: (builder) => ({
    getBanks: builder.query<GetBanksResponse, GetBanksRequest>({
      query: (params) => {
        return {
          url: `/banks`,
          method: "GET",
          params: {
            ...params,
          },
        };
      },
    }),
  }),
});

export const { useGetBanksQuery, useLazyGetBanksQuery } = bankApi;
export const { useQueryState: useGetWalletByOrgIdQueryState } =
  bankApi.endpoints.getBanks;
